import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface SnackbarProps {
  timeout?: number;
  key?: number;
  message?: string | null;
  variant?: 'success' | 'info' | 'warning' | 'error';
}

export const INFINITE_TIME = -1;

export const useNotificationStore = defineStore('notificationStore', () => {
  const isDisplayed = ref<boolean>(false);
  const snackbar = ref<SnackbarProps>({});

  const setSnackBar = ({ message, timeout = 5_000, variant = 'info' }: SnackbarProps) => {
    isDisplayed.value = true;
    snackbar.value = { message, timeout, variant, key: Date.now() };
  };

  const closeSnackbar = () => {
    isDisplayed.value = false;
    snackbar.value = {};
  };

  return {
    snackbar,
    isDisplayed,
    closeSnackbar,
    setSnackBar,
  };
});
